import React from 'react'
import styled from 'react-emotion'
import cursor2 from '../../../../media/img/icons/new-thread-2.png'
import cursor from '../../../../media/img/icons/new-thread.png'
import { discussBlockHighlight } from '../../../style'

const cursorStyles = {
  cursor: `url("${cursor}") 10 10, crosshair`,
  '&': {
    cursor: `-webkit-image-set(url("${cursor}") 1x, url("${cursor2}") 2x) 10 10, crosshair`
  }
}
const PlaceThreadBlock = styled('div')({
  position: 'absolute',
  ...cursorStyles,
  '&:hover': discussBlockHighlight
})
const PlaceThreadSection = styled('div')({
  position: 'absolute',
  width: '100%',
  ...cursorStyles
})

const PlaceThread = ({
  blocks,
  sections,
  placeBlockThread,
  placeSectionThread
}) => (
  <>
    {/* Sections */}
    {(sections || []).map(section => (
      <PlaceThreadSection
        style={{ top: section.top, height: section.height }}
        onClick={e => placeSectionThread(e, section.id)}
        key={section.id}
      />
    ))}

    {/* Blocks */}
    {(blocks || []).map(block => (
      <PlaceThreadBlock
        style={block.layout}
        onClick={e => placeBlockThread(e, block.id)}
        key={block.id}
      />
    ))}
  </>
)

export default PlaceThread
